import { IInvoicePDF } from './type';
import { View, Text } from 'react-native';
import { WebView } from 'react-native-webview';
import React from 'react';
import { ViewPdf } from './components/ViewPdf';

const InvoicePdf: React.FC<IInvoicePDF> = (attrs) => {
  return (
    <View
      style={{
        width: attrs.width,
        height: attrs.height,
      }}
    >
      <ViewPdf {...attrs} />
    </View>
  );
};

export default InvoicePdf;
